import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { PageHeader } from "../../components/v3";
import { PurchaseReturn } from "../../components/vendor";
import { PageLayout } from "../../layouts/PageLayout";

export const ReturnPurchase = () => {
  const { invoiceId } = useParams();
  return (
    <>
      <PageLayout>
        {/* header section */}
        <PageHeader title="Return Purchase" />

        {/* return purchase */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <PurchaseReturn purchaseInvoiceId={invoiceId} />
        </Box>
      </PageLayout>
    </>
  );
};
